import React, { useState } from 'react';
import { Tabs } from 'antd';

interface ApplicationWorkspaceProps {
  header: React.ReactNode;
  sidebar: React.ReactNode;
  main: React.ReactNode;
  pipeline: React.ReactNode;
}

const ApplicationWorkspace: React.FC<ApplicationWorkspaceProps> = ({
  header,
  sidebar,
  main,
  pipeline,
}) => {
  const [mobileTab, setMobileTab] = useState('details');

  return (
    <div className="job-application-workspace job-application-workspace--premium">
      {header}

      <div className="application-workspace-layout">
        <div className="min-w-0">{sidebar}</div>
        <div className="application-panel application-main-panel">{main}</div>
        <div className="min-w-0">{pipeline}</div>
      </div>

      <div className="application-workspace-mobile">
        <Tabs
          activeKey={mobileTab}
          onChange={setMobileTab}
          className="application-mobile-tabs"
          items={[
            {
              key: 'candidate',
              label: 'Candidate',
              children: sidebar,
            },
            {
              key: 'details',
              label: 'Details',
              children: (
                <div className="application-panel application-main-panel">
                  {main}
                </div>
              ),
            },
            {
              key: 'pipeline',
              label: 'Pipeline',
              children: pipeline,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ApplicationWorkspace;
